import { Link, Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-primary-50 via-surface to-primary-100 p-4">
      <div className="w-full max-w-md">
        {/* Branding */}
        <Link to="/" className="mb-8 text-center block">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-600 shadow-lg">
            <span className="text-2xl font-bold text-white">FM</span>
          </div>
          <h1 className="text-2xl font-bold text-text-primary">FlyMind</h1>
          <p className="mt-1 text-sm text-text-secondary">
            L'AI che ti dice quando prenotare
          </p>
        </Link>

        {/* Content card */}
        <div className="rounded-2xl border border-border bg-surface p-6 shadow-sm md:p-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
